<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-header classes="no-border">
        <h3>
          <ng-container *ngIf="editmode; else noeditmodeheader">
            {{'nav.contentEditor.templates.edit' | translate}}
          </ng-container>
          <ng-template #noeditmodeheader>
            {{'nav.contentEditor.createContentFromTemplate' | translate}}
          </ng-template>
        </h3>
        <small>
          {{'lang.contentEditor.template' | translate}}&nbsp;<b>{{Name?.value}}</b>&nbsp;
        </small>
      </div>
      <div card-header-more>
        <div class="d-flex align-items-center">
          <ng-container *ngIf="showPreviewButton">
            <form [formGroup]="previewForm">
              <div class="d-flex align-items-center">
                <div class="form-group validateMe">
                  <sb-button id="selectMarker" (click)="selectMarker()"
                             classes="btn-hover-primary mr-1">
                    <sb-icon icon="marker"></sb-icon>
                  </sb-button>
                  <span class="form-text text-muted"></span>
                </div>
                <div class="form-group validateMe mt-4 mr-1">
                  <input type="number" id="Width" class="form-control"
                         formControlName="Width">
                  <span
                    class="form-text text-muted">{{'lang.globals.preview' | translate}}&nbsp;{{'lang.globals.widthDescription' | translate}}</span>
                  <div *ngIf="Width.touched && Width.errors?.required"
                       class="alert alert-danger">
                    {{'lang.globals.widthWarning' | translate}}</div>
                </div>
                <div class="form-group validateMe mt-4 mr-1">
                  <input type="number" id="Height" class="form-control"
                         formControlName="Height">
                  <span
                    class="form-text text-muted">{{'lang.globals.preview' | translate}}&nbsp;{{'lang.globals.heightDescription' | translate}}</span>
                  <div *ngIf="Height.touched && Height.errors?.required"
                       class="alert alert-danger">
                    {{'lang.globals.heightWarning' | translate}}</div>
                </div>
                <div class="form-group validateMe" *ngPermissions="permissionService.Permission.medium_upload">
                  <label class="form-label" for="preview"></label>
                  <button id="preview" (click)="preview()" [disabled]="!previewForm.valid"
                          class="btn btn-hover-primary mr-1">
                    <sb-icon
                      icon="preview"></sb-icon>&nbsp;{{"lang.globals.preview" | translate}}
                  </button>
                  <span class="form-text text-muted"></span>
                </div>
              </div>
            </form>
          </ng-container>
        </div>
      </div>
      <div card-fit>
        <sb-wizard #wizard [hideTabs]="true">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings" [active]="true">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="my-4">{{'lang.globals.details' | translate}}</h3>
                  <div class="row">
                    <div class="col-md-12 col-lg-3">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Title">{{'lang.globals.name' | translate}}</label>
                        <input type="text" id="Title" class="form-control"
                               formControlName="Name">
                        <span
                          class="form-text text-muted">{{'lang.globals.nameDescription' | translate}}</span>
                        <div *ngIf="Name.touched && Name.errors?.required"
                             class="alert alert-danger">
                          {{'lang.globals.nameWarning' | translate}}</div>
                      </div>
                    </div>
                    <div class="col-md-12 col-lg-9">
                      <div class="form-group validateMe">
                        <label class="form-label"
                               for="Description">{{'lang.globals.description' | translate}}</label>
                        <input type="text" id="Description" class="form-control"
                               formControlName="Description">
                        <span
                          class="form-text text-muted">{{'lang.globals.descriptionDescription' | translate}}</span>
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed d-md-none">
                </div>
              </div>
              <div class="wizard__footerActions">
                <button type="button" (click)="cancel()"
                           class="btn btn-default btn-lg btn-wide">
                  {{'lang.globals.cancel' | translate}}
                </button>
                <button (click)="showEditor = true; nextStep(wizard, tab2); reloadEditor()" [disabled]="!form.valid"
                           class="btn btn-success btn-wide btn-lg" type="button">
                  {{'lang.globals.next' | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
          <sb-wizard-tab #tab2 titleText="{{ 'lang.globals.edit' | translate }}" icon="edit" [active]="false">
            <form [formGroup]="form" class="wizard__forms pb-5">
              <div class="row">
                <div class="col-md-12">
                  <!-- <h3 class="my-4">{{'lang.globals.edit' | translate}}</h3> -->
                  <div class="row">
                    <div class="col-md-12">
                      <ng-container *ngIf="loadEditor">
                        <email-editor [projectId]="projectId" [displayMode]="displayMode"
                                      [locale]="locale" [dockSide]="dockSide"
                                      [theme]="theme" [preview]="editorPreview"
                                      [stockImages]="stockImages" (loaded)="editorLoaded()"
                                      [user]="user"
                                      [signature]="signature">
                        </email-editor>
                      </ng-container>
                    </div>
                  </div>
                  <hr class="border-dashed d-md-none">
                </div>
              </div>
              <div class="wizard__footerActions px-5">
                <button
                  type="button"
                  (click)="showEditor = false; showPreviewButton = false; nextStep(wizard, tab1); reloadEditor()"
                  class="btn btn-default btn-lg btn-wide">
                  {{'lang.globals.back' | translate}}
                </button>
                <button type="button" (click)="submit()" [disabled]="!form.valid || loading"
                           class="btn btn-success btn-wide btn-lg">
                  {{'lang.globals.submit' | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
